import { render } from "./ProductProcess.vue?vue&type=template&id=47f38b27&scoped=true"
import script from "./ProductProcess.vue?vue&type=script&lang=js"
export * from "./ProductProcess.vue?vue&type=script&lang=js"

import "./ProductProcess.vue?vue&type=style&index=0&id=47f38b27&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47f38b27"]])

export default __exports__